import httpBuildQuery from '../../procedures/http-build-query';

export default ({ baseUri, modelName }) => ({
  index: async (query) => await axios.get(baseUri + httpBuildQuery(query)),
  list: async () => await axios.get(`${ baseUri }?list`),
  store: async (data) => await axios.post(baseUri, { [modelName]: data }),
  show: async ({ id }) => await axios.get(`${ baseUri }/${ id }`),
  showByOriginal: async ({ id }) => await axios.get(`${ baseUri }/by-original/${ id }`),
  softDelete: async (item) => await axios.delete(`${ baseUri }/${ item.id }`,
    { data: item?.additionalData },
  ),
  update: async (data) => await axios.put(`${ baseUri }/${ data.id }`, { [modelName]: data }),
});
